import hasAccessRightMixin from "@/mixins/hasAccessRight";

export default function registerHasAccessRights(app) {
  app.mixin(hasAccessRightMixin);
}
